var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 113,
    viewBox: "0 0 300 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.906 3.39496C293.572 2.34217 292.448 1.75965 291.395 2.09387L274.239 7.54029C273.186 7.87451 272.603 8.99891 272.938 10.0517C273.272 11.1045 274.396 11.687 275.449 11.3528L290.699 6.51153L295.54 21.7615C295.874 22.8143 296.999 23.3968 298.052 23.0626C299.104 22.7284 299.687 21.604 299.353 20.5512L293.906 3.39496ZM0.0514895 1.45102C3.67377 17.1044 17.1284 38.1451 36.6916 57.5905C56.3056 77.0862 82.2956 95.2171 111.304 104.897C140.343 114.587 172.455 115.819 204.133 101.398C235.79 86.988 266.763 57.0619 293.776 4.92013L290.224 3.08011C263.487 54.6883 233.085 83.8246 202.476 97.7579C171.889 111.681 140.845 110.538 112.571 101.103C84.2669 91.6581 58.7882 73.914 39.5115 54.7535C20.1841 35.5426 7.32623 15.1458 3.94851 0.549227L0.0514895 1.45102Z",
    fill: "#495057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e2a0b9ba2054c75518193c9836d99e1f.svg";
export { ForwardRef as ReactComponent };